import Transform from '@ember-data/serializer/transform';
import Money from '@square/dashboard-money/models/money';

/**
 * We need to override the serialize method in LegacyMoney this is being done
 * so that we can pass through a currency (SQ_2) without passing through an associated
 * amount, as our amount is set in max_item_price or max_total_amount
 */
// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  serialize(money) {
    if (!money) {
      return null;
    }
    if (money.amount) {
      return {
        cents: money.get('amount'),
        currency_code: money.get('currencyCode')
      };
    } else {
      return {
        currency_code: money.get('currencyCode')
      };
    }
  },
  deserialize(hash) {
    if (!hash) {
      return null;
    }
    if (hash._currencyCode) {
      hash.currency_code = hash._currencyCode;
    }
    if (hash._amount) {
      hash.cents = hash._amount;
    }
    return Money.create({
      amount: hash.cents,
      currencyCode: hash.currency_code
    });
  }
});